import { RegularButton, Typography } from 'fronton-react';
import { TypographyProps } from 'fronton-react/typography/types';
import React from 'react';
import { getPriceText } from 'utils';
import { btnStyles, CardPriceWrapper, FlexRow } from './styled';

type CardPriceProps = {
	price: number;
	unit?: string | null;
	className?: string;
	mainPriceColor?: TypographyProps['color'];
};

export const CardPrice = ({
	price,
	unit = null,
	className = '',
	mainPriceColor,
}: CardPriceProps) => (
	<CardPriceWrapper className={className}>
		<FlexRow>
			<div data-analyticsName="productPriceLink">
				<Typography variant="s" size="body_accent" color={mainPriceColor}>
					от&nbsp;
				</Typography>
				<Typography
					variant="l"
					size="body_accent"
					data-qa="card-price"
					color={mainPriceColor}
				>
					{getPriceText(price)}
				</Typography>
				<Typography
					variant="s"
					size="body_accent"
					data-qa="card-unit"
					color={mainPriceColor}
				>
					&nbsp;₽{unit && `/${unit}`}
				</Typography>
			</div>
		</FlexRow>

		<RegularButton
			variant="primary"
			size="s"
			className={btnStyles}
			data-qa="card-order-btn"
			data-analyticsName="productButtonLink"
		>
			Заказать
		</RegularButton>
	</CardPriceWrapper>
);
